export default {
    //繁体
    
}